import pmsInstance from '../instance'
import { GuestsQuery } from './types'

const getGuests = (params: GuestsQuery) => {
	return pmsInstance.get('/guests', { params })
}

export default getGuests
